var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path9, _path10, _path11, _path12, _line3, _line4, _path13, _path14, _rect9, _rect10, _rect11, _path15, _rect12, _rect13, _rect14, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 353,
    viewBox: "0 0 637 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.382 217.985L340.869 132.04C340.796 130.847 341.562 128.638 345.214 129.354L516.95 129.354C518.716 128.981 522.914 129.534 525.578 134.726L569.492 195.156C570.844 197.021 574.367 200.751 577.638 200.751L634.643 200.751",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.155 218.209L295.644 132.183C295.731 130.988 294.989 128.777 291.326 129.494L119.453 129.494C117.69 129.121 113.483 129.674 110.757 134.872L66.1215 195.373C64.7468 197.24 61.1789 200.975 57.9051 200.975L0.854912 200.975",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.601 316.911L294.56 324.073C294.635 325.117 294.158 327.206 291.656 327.206L221.663 327.206C221.022 327.206 219.265 325.953 217.369 320.94C216.953 319.838 214.995 315.017 212.016 307.735M0.737039 221.79L20.821 221.79M138.139 189.784L138.118 193.365L138.16 185.979M138.139 189.784L149.504 189.784M138.139 189.784L126.774 189.784M149.504 189.784L160.869 189.784C162.985 189.784 164.463 192.172 164.937 193.365C175.141 218.091 191.762 258.404 203.57 287.144M149.504 189.784L149.483 193.365L149.525 185.979M126.774 189.784L115.409 189.784C113.967 189.635 110.404 190.142 107.692 193.365L97.1586 205.787M126.774 189.784L126.754 193.365L126.796 185.979M97.1586 205.787L86.6252 218.209C85.4158 219.402 82.6121 221.79 81.0727 221.79L60.9888 221.79M97.1586 205.787L107.621 205.787L86.6957 205.787M40.9049 221.79L40.8782 226.49M40.9049 221.79L60.9888 221.79M40.9049 221.79L20.821 221.79M60.9888 221.79L60.9621 226.49M20.821 221.79L20.7943 226.49M212.016 307.735L223.698 307.735M212.016 307.735C210.775 304.7 209.356 301.238 207.797 297.439M207.797 297.439L223.756 297.439M207.797 297.439C206.48 294.229 205.064 290.779 203.57 287.144M203.57 287.144L223.815 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.829 316.911L339.788 324.073C339.702 325.117 340.155 327.206 342.656 327.206L412.65 327.206C413.291 327.206 415.062 325.953 417.015 320.94C417.444 319.838 419.456 315.017 422.518 307.735M634.772 221.79L614.689 221.79M497.734 189.784L497.714 193.365L497.756 185.979M497.734 189.784L486.369 189.784M497.734 189.784L509.099 189.784M486.369 189.784L475.004 189.784C472.888 189.784 471.383 192.172 470.895 193.365C460.41 218.091 443.332 258.404 431.197 287.144M486.369 189.784L486.349 193.365L486.391 185.979M509.099 189.784L520.464 189.784C521.908 189.635 525.465 190.142 528.14 193.365L538.533 205.787M509.099 189.784L509.079 193.365L509.12 185.979M538.533 205.787L548.925 218.209C550.121 219.402 552.897 221.79 554.437 221.79L574.521 221.79M538.533 205.787L528.07 205.787L548.995 205.787M594.605 221.79L594.578 226.49M594.605 221.79L574.521 221.79M594.605 221.79L614.689 221.79M574.521 221.79L574.494 226.49M614.689 221.79L614.662 226.49M422.518 307.735L410.836 307.735M422.518 307.735C423.794 304.7 425.252 301.238 426.853 297.439M426.853 297.439L410.894 297.439M426.853 297.439C428.207 294.229 429.662 290.779 431.197 287.144M431.197 287.144L410.953 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M318.345 201.87L319.351 24.6092C319.355 23.8631 319.845 22.371 321.769 22.371L524.051 22.371C526.296 22.4456 530.789 21.8339 530.806 18.79C530.824 15.7461 530.869 7.6739 530.89 4.01826C530.815 3.12301 531.242 1.33249 533.551 1.33249L625.502 0.999998",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317.837 201.87L318.34 113.24L318.843 24.6092C318.848 23.8631 318.376 22.371 316.455 22.371L114.479 22.371C112.238 22.4456 115.85 21.6537 115.867 18.6099C115.884 15.566 115.93 7.49375 115.951 3.83812C116.036 2.94286 107.538 1.33249 105.233 1.33249L11.0157 1.15234",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.594 337.726L317.548 345.783C317.376 347.723 318.092 351.602 322.325 351.602L497.188 351.602C498.47 351.751 501.954 350.886 505.637 346.231L563.291 274.162C564.34 272.894 566.872 270.357 568.604 270.357L634.268 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M316.592 337.726L316.546 345.783C316.695 347.723 315.936 351.602 311.703 351.602L136.84 351.602C135.556 351.751 132.082 350.886 128.452 346.231L71.616 274.162C70.5809 272.894 68.0778 270.357 66.346 270.357L0.68242 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 537.76 22.5947)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 2.34863 22.595)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 21.7721,
    transform: "matrix(-0.00364558 0.999993 -0.999957 -0.00932152 224.549 285.586)",
    fill: "url(#paint0_linear_424_3452)",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 21.7721,
    transform: "matrix(-0.00364549 0.999993 0.999998 -0.00203057 410.777 286.264)",
    fill: "url(#paint1_linear_424_3452)",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 9.30272,
    transform: "matrix(0.999988 0.00423916 0.00392989 -0.999994 293.37 251.865)",
    fill: "url(#paint2_linear_424_3452)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 17.4426,
    transform: "matrix(0.999988 0.00423916 -0.00392989 0.999994 293.32 264.656)",
    fill: "url(#paint3_linear_424_3452)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 16.2798,
    transform: "matrix(0.999988 0.00423916 0.00392989 -0.999994 317.369 251.967)",
    fill: "url(#paint4_linear_424_3452)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 30.2338,
    transform: "matrix(0.999988 0.00423916 -0.00392989 0.999994 317.319 264.758)",
    fill: "url(#paint5_linear_424_3452)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 9.30272,
    transform: "matrix(0.999988 0.00423916 0.00392989 -0.999994 339.369 252.06)",
    fill: "url(#paint6_linear_424_3452)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 17.4426,
    transform: "matrix(0.999988 0.00423916 -0.00392989 0.999994 339.319 264.851)",
    fill: "url(#paint7_linear_424_3452)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.999 162.842L67.999 192.842C63.5991 200.442 59.4991 201.342 57.999 200.842L50 201",
    stroke: "url(#paint8_linear_424_3452)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M545.999 162.842L567.999 192.842C572.399 200.442 576.499 201.342 577.999 200.842H586",
    stroke: "url(#paint9_linear_424_3452)",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.999 205.842L106.499 194.842C107.832 193.175 111.599 189.842 115.999 189.842C120.399 189.842 122.499 189.842 122.999 189.842",
    stroke: "url(#paint10_linear_424_3452)",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M538.999 205.842L529.499 194.842C528.166 193.175 524.399 189.842 519.999 189.842C515.599 189.842 513.499 189.842 512.999 189.842",
    stroke: "url(#paint11_linear_424_3452)",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 86.7845,
    y1: 293.223,
    x2: 112.785,
    y2: 326.223,
    stroke: "url(#paint12_linear_424_3452)",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 42.0119,
    y2: -1,
    transform: "matrix(-0.618872 0.785492 0.785492 0.618872 548.999 293.842)",
    stroke: "url(#paint13_linear_424_3452)",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M154.878 22.3418C146.211 22.3418 127.478 22.3418 121.878 22.3418C116.278 22.3418 115.545 18.6751 115.878 16.8418L115.878 12.3418",
    stroke: "url(#paint14_linear_424_3452)",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M491.878 22.3418C500.545 22.3418 519.278 22.3418 524.878 22.3418C530.478 22.3418 531.211 18.6751 530.878 16.8418L530.878 12.3418",
    stroke: "url(#paint15_linear_424_3452)",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 620.013 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 605.088 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 590.164 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M575.236 193.664C575.238 193.252 575.574 192.918 575.986 192.918L584.312 192.918C585.417 192.918 586.307 193.813 586.301 194.918L586.298 195.549C586.292 196.568 585.461 197.394 584.442 197.394L578.945 197.394C576.884 197.394 575.224 195.724 575.236 193.664Z",
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 16.3062 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 31.2305 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 46.1548 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0749 193.664C61.0772 193.252 60.7451 192.918 60.333 192.918L52.0064 192.918C50.9018 192.918 50.0013 193.813 49.995 194.918L49.9914 195.549C49.9856 196.568 50.8072 197.394 51.8264 197.394L57.3234 197.394C59.3836 197.394 61.0632 195.724 61.0749 193.664Z",
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_424_3452",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 21.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_424_3452",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 21.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_424_3452",
    x1: 1,
    y1: 9.30272,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_424_3452",
    x1: 1,
    y1: 17.4426,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_424_3452",
    x1: 1,
    y1: 16.2798,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_424_3452",
    x1: 1,
    y1: 30.2338,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_424_3452",
    x1: 1,
    y1: 9.30272,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_424_3452",
    x1: 1,
    y1: 17.4426,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_424_3452",
    x1: 58.999,
    y1: 200.842,
    x2: 93.999,
    y2: 169.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_424_3452",
    x1: 576.999,
    y1: 200.842,
    x2: 541.999,
    y2: 169.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_424_3452",
    x1: 98.499,
    y1: 204.842,
    x2: 123.999,
    y2: 198.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_424_3452",
    x1: 537.499,
    y1: 204.842,
    x2: 511.999,
    y2: 198.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_424_3452",
    x1: 85.6063,
    y1: 294.151,
    x2: 111.606,
    y2: 327.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_424_3452",
    x1: 0,
    y1: 0.5,
    x2: 42.0119,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_424_3452",
    x1: 118.064,
    y1: 21.7168,
    x2: 148.699,
    y2: 4.38743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_424_3452",
    x1: 528.691,
    y1: 21.7168,
    x2: 498.057,
    y2: 4.38743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame12);
export default __webpack_public_path__ + "static/media/card1-frame12.021822accfe304ede0c58f50ca381281.svg";
export { ForwardRef as ReactComponent };